import { compact } from "@/lib/format";
import { Explain } from "@/components/Explain";
import { cashFlowLevel, level, retirementLevel } from "@/lib/insights";

export const lifeGapRows = (s) => [
  { key: "life-c", label: `Life · ${s.d.profile.name || "Client"}`, need: s.ins.client.totalNeed, available: s.ins.client.totalNeed - s.ins.client.lifeAdditional, gap: s.ins.client.lifeAdditional },
  { key: "ci-c", label: `CI · ${s.d.profile.name || "Client"}`, need: s.ins.client.ciRequired, available: s.ins.client.ciRequired - s.ins.client.ciAdditional, gap: s.ins.client.ciAdditional },
  ...(s.ins.hasSpouse ? [
    { key: "life-s", label: `Life · ${s.d.profile.spouse.name || "Spouse"}`, need: s.ins.spouse.totalNeed, available: s.ins.spouse.totalNeed - s.ins.spouse.lifeAdditional, gap: s.ins.spouse.lifeAdditional },
    { key: "ci-s", label: `CI · ${s.d.profile.spouse.name || "Spouse"}`, need: s.ins.spouse.ciRequired, available: s.ins.spouse.ciRequired - s.ins.spouse.ciAdditional, gap: s.ins.spouse.ciAdditional },
  ] : []),
];

const TONE = { green: "text-emerald-600", amber: "text-amber-600", red: "text-rose-600", grey: "text-slate-400", blue: "text-slate-900" };

const Card = ({ label, value, lvl = "blue", testId, sub, s, k, cur }) => (
  <Explain s={s} k={k} cur={cur} testId={`${testId}-explain`} className={`kpi-card lvl-${lvl}`}>
    <span className="metric-label truncate flex items-center gap-1.5"><span className="lvl-dot" />{label}</span>
    <span className={`font-mono text-[15px] font-bold leading-tight ${TONE[lvl]}`} data-testid={testId}>{value}</span>
    {sub && <span className="text-[10.5px] text-slate-500 truncate">{sub}</span>}
  </Explain>
);

export const KpiStrip = ({ s, cur }) => {
  const c = s.ins.client;
  const short = s.ret.monthlySurplus < 0;
  const cf = s.ov.cashFlow;
  const p = { s, cur };
  return (
    <div className="kpi-strip" data-testid="kpi-strip">
      <Card {...p} k="networth" label="Net worth" value={compact(s.ov.netWorth, cur)} testId="kpi-net-worth" />
      <Card {...p} k="cashflow" label="Cash flow / mo" value={cf === null ? "Enter take-home" : compact(cf, cur)} lvl={cashFlowLevel(s)} testId="kpi-cash-flow" />
      <Card {...p} k="retirement" label={short ? "Retirement shortfall" : "Retirement surplus"} value={`${compact(s.ret.monthlySurplus, cur)}/mo`} lvl={retirementLevel(s)} sub={short ? `Save ${compact(s.ret.monthlyContribution, cur)}/mo` : `at age ${s.ret.retAge}`} testId="kpi-retirement" />
      <Card {...p} k="fin" label="FIN" value={compact(s.ret.fin, cur)} testId="kpi-fin" />
      <Card {...p} k="life-client" label="Life ins. needed" value={c.lifeAdditional > 0 ? compact(c.lifeAdditional, cur) : "Covered"} lvl={level(c.lifeAdditional, c.totalNeed)} sub={s.ins.hasSpouse ? `Spouse: ${s.ins.spouse.lifeAdditional > 0 ? compact(s.ins.spouse.lifeAdditional, cur) : "Covered"}` : undefined} testId="kpi-life" />
      <Card {...p} k="di-client" label="Disability gap / mo" value={c.diShortfall > 0 ? compact(c.diShortfall, cur) : "Covered"} lvl={level(c.diShortfall, c.diRequired)} testId="kpi-di" />
      <Card {...p} k="ci-client" label="Critical illness gap" value={c.ciAdditional > 0 ? compact(c.ciAdditional, cur) : "Covered"} lvl={level(c.ciAdditional, c.ciRequired)} testId="kpi-ci" />
    </div>
  );
};
